// @flow

import addEstimateCaveat from '../../../Services/addEstimateCaveat';
import type { AddEstimateCaveatParams } from '../../../types';

export default (params: AddEstimateCaveatParams) => async (dispatch: Function) => dispatch(addEstimateCaveat(params))